import axios from 'axios'
import { REACT_APP_PRECIOJUSTO_API } from '../../config'

export async function updateConfigurations(data) {
    const value = parseInt(data.value)
    if (!Number.isInteger(value)) throw new Error('value must be integer')

    const dataUpdate = {
        updatedAt: new Date(),
        value,
    }
    try {
        const response = await axios.patch( `${REACT_APP_PRECIOJUSTO_API}/configurations/${data.id}`, dataUpdate)
        return response?.data
    } catch (error) {
        return error
    }
}
